/**
 * Verification Success Component
 * Where the user is notified that they are verified and taken back to the map
 */
import { useRouter } from 'next/navigation'
import React, { useEffect } from 'react'

import { LoadingSpinner } from '.'
import { Horn } from '../icons'

interface VerificationSuccessProps {
  redirectUrl?: string
}

export default function VerificationSuccess ({ redirectUrl }: VerificationSuccessProps): React.JSX.Element {
  const router = useRouter()

  useEffect(() => {
    if (redirectUrl) {
      const timer = setTimeout(() => {
        router.replace(redirectUrl)
      }, 2000) // 2 second delay

      return () => clearTimeout(timer)
    }
  }, [redirectUrl, router])

  return (
    <div>
      <Horn width={114} className="mx-auto" />

      <h2 className="mt-6 text-center text-2xl font-extrabold text-neutrals-800">
        You're in!
      </h2>

      <div className="my-5 px-4 border-t border-neutrals-300 w-full" />
      <p className="text-center text-sm text-neutrals-600">Taking you back to the map</p>

      <LoadingSpinner className="mt-6" />
    </div>
  )
}
